import { LocalizationModel } from '@shared/core';
import { ICoordinatesModel } from './coordinates.model';
import { IBaseResponseModel, IBaseValueModel } from './base.model';

export interface IParkingModel {
  uuid?: string | IBaseValueModel;
  name?: LocalizationModel;
  description?: LocalizationModel;
  contacts?: LocalizationModel;
  timezone?: string;
  spacesTotal?: number;
  spacesHandicapped?: number;
  center?: ICoordinatesModel;
  location?: IParkingLocationModel;
  address?: IParkingAddress;
  spaces_total?: number;
  zoneUuid?: IBaseValueModel;
  categoryUuid?: IBaseValueModel;
  status: IParkingStatusEnum;
  parkingType: IParkingTypeEnum;
  parkingLayout: IParkingLayoutEnum;
}

export interface IParkingAddress {
  city: string;
  country: string;
  house: LocalizationModel;
}

export interface IParkingLocationModel {
  polygon?: IParkingLocationPolygon;
  line?: IParkingLocationPolygon;
  point?: ICoordinatesModel;
  type: IParkingLocationEnum;
}

export enum IParkingLocationEnum {
  Polygon = 'GIS_TYPE_POLYGON',
  Line = 'GIS_TYPE_LINE',
  Point = 'GIS_TYPE_POINT',
}

export const IParkingLocationEnumMapper: Record<IParkingLocationEnum, string> = {
  [IParkingLocationEnum.Polygon]: 'Полигон',
  [IParkingLocationEnum.Line]: 'Линия',
  [IParkingLocationEnum.Point]: 'Точка',
};

export interface IParkingLocationPolygon {
  coordinates: ICoordinatesModel[];
}

export interface IParkingResponseModel extends IBaseResponseModel {
  parkings: IParkingModel[];
}

export interface IParkingCategoriesResponseModel {
  categories: IParkingCategoryModel[];
}

export interface IParkingCategoryModel {
  uuid: IBaseValueModel;
  name: LocalizationModel;
  children: IParkingSubCategoryModel[];
}

export interface IParkingSubCategoryModel {
  uuid: IBaseValueModel;
  parentUuid?: IBaseValueModel;
  name: LocalizationModel;
  type: string;
  zoneType: string;
}

export enum MapTypeEnum {
  Zone = 'zone',
  Parking = 'parking',
}

export enum MapIconTypeEnum {
  Camera = 'CAMERA',
  Gate = 'GATE',
}

export enum IParkingStatusEnum {
  Unspecified = 'PARKING_STATUS_UNSPECIFIED',
  Active = 'PARKING_STATUS_ACTIVE',
  Inactive = 'PARKING_STATUS_INACTIVE',
  Closed = 'PARKING_STATUS_CLOSED',
}

export const IParkingStatusLabel: Record<IParkingStatusEnum, string> = {
  [IParkingStatusEnum.Unspecified]: 'ADMIN_MANAGEMENT_PARKING_STATUS_UNSPECIFIED',
  [IParkingStatusEnum.Active]: 'ADMIN_MANAGEMENT_PARKING_STATUS_ACTIVE',
  [IParkingStatusEnum.Inactive]: 'ADMIN_MANAGEMENT_PARKING_STATUS_INACTIVE',
  [IParkingStatusEnum.Closed]: 'ADMIN_MANAGEMENT_PARKING_STATUS_CLOSED',
};

export enum IParkingTypeEnum {
  Parallel = 'parallel',
  Perpendicular = 'perpendicular',
  Diagonal = 'diagonal',
}

export const IParkingTypeLabel: Record<IParkingTypeEnum, string> = {
  [IParkingTypeEnum.Parallel]: 'ADMIN_MANAGEMENT_PARKING_TYPE_PARALLEL',
  [IParkingTypeEnum.Perpendicular]: 'ADMIN_MANAGEMENT_PARKING_TYPE_PERPENDICULAR',
  [IParkingTypeEnum.Diagonal]: 'ADMIN_MANAGEMENT_PARKING_TYPE_DIAGONAL',
};

export enum IParkingLayoutEnum {
  Right = 'right',
  Left = 'left',
  Both = 'both',
}

export const IParkingLayoutLabel: Record<IParkingLayoutEnum, string> = {
  [IParkingLayoutEnum.Right]: 'ADMIN_MANAGEMENT_PARKING_LAYOUT_RIGHT',
  [IParkingLayoutEnum.Left]: 'ADMIN_MANAGEMENT_PARKING_LAYOUT_LEFT',
  [IParkingLayoutEnum.Both]: 'ADMIN_MANAGEMENT_PARKING_LAYOUT_BOTH',
};
